export default (target, valProp) => {
    return `L. ${target[valProp].toLocaleString(target['locale'] || navigator.language, {
        // style: "currency",
        // currency: target['currency'] || 'USD'
        minimumFractionDigits: 2,
    })}`
}